import {ValidatorInfo} from '@core/models/validator.model';

export const VALIDATORS: {[key: string]: ValidatorInfo[]} = {
  "username": [
    {
      errorName: "required",
      errorDescription: "Vui lòng nhập tên"
    },
    {
      errorName: "notExist",
      errorDescription: "Người dùng không tồn tại"
    },
    {
      errorName: "needVerify",
      errorDescription: "Tài khoản chưa được kích hoạt"
    },
    {
      errorName: "locked",
      errorDescription: "Tài khoản đã bị khóa"
    },


  ],
  "password": [
    {
      errorName: "required",
      errorDescription: "Vui lòng nhập mật khẩu"
    },
    {
      errorName: "notMatch",
      errorDescription: "Mật khẩu không đúng. Vui lòng thử lại"
    }
  ]
}

export const FORM_VALIDATORS: ValidatorInfo[] = [
  {
    errorName: "systemError",
    errorDescription: "Hệ thống đang bận. Vui lòng thử lại sau."
  }
]
